<template>
  <div class="winpot-register">
    <div class="modal fade" id="registerModalToggle" aria-hidden="true" aria-labelledby="registerModalToggleLabel"
      tabindex="-1" data-bs-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content winpot-modal">
          <div class="modal-header winpot-modal__header">
            <div @click="openSupportModalJivo()" class="winpot-modal__icon-btn winpot-modal__support">
              <img src="https://winpot.mx/assets/images/support.svg" alt="support" class="winpot-modal__icon" />
            </div>
            <div class="winpot-progress">
              <div class="winpot-progress__wrapper">
                <span class="winpot-progress__indicator winpot-progress__indicator--current" aria-hidden="true"></span>
                <span class="winpot-progress__line" aria-hidden="true"></span>
                <span class="winpot-progress__indicator winpot-progress__indicator--inactive" aria-hidden="true"></span>
              </div>
            </div>
            <!-- <span class="winpot-modal__icon-spacer" aria-hidden="true"></span> -->
            <button type="button" class="winpot-modal__icon-btn winpot-modal__close" data-bs-dismiss="modal"
              aria-label="Close">
              <img src="https://winpot.mx/assets/images/close.svg" alt="close" class="winpot-modal__icon" />
            </button>
          </div>
          <div class="modal-body winpot-modal__body">
            <div class="winpot-step">

              <div class="winpot-modal__intro">
                <img v-if="skin.register_other_url != ''" :src="skin.register_other_url" width="100%"
                  alt="register_image" class="winpot-modal__logo" />
                <h2 class="winpot-modal__title">{{ translate("¡ABRIR UNA CUENTA!") }}</h2>
                <p class="winpot-modal__subtitle">{{ registrationSubtitle }}</p>
              </div>
              <form class="winpot-form" @submit.prevent="nextStep($event)">
                <div class="mb-3 winpot-field">
                  <label class="winpot-label" for="registerUsername">
                    {{ userNameLabel }}
                  </label>
                  <input v-model.trim="new_user_data.username" type="text" minlength="5" id="registerUsername"
                    class="form-control winpot-input" :class="{ 'is-invalid': errors.username }"
                    :placeholder="translate('enter_username')" aria-label="registerUsername"
                    aria-describedby="registerUsername" autocomplete="username" required
                    @keydown.space.prevent
                    @input="normalizeUsername" />
                  <div class="invalid-feedback" v-if="errors.username">{{ errors.username }}</div>
                </div>
                <div class="mb-3 winpot-field">
                  <label class="winpot-label" for="RegisterPassword">{{
                    translate("password")
                  }}</label>
                  <div class="winpot-password-wrapper">
                    <input v-model="new_user_data.password" id="RegisterPassword"
                      :type="showPassword ? 'text' : 'password'" minlength="8" maxlength="20"
                      class="form-control winpot-input" :class="{ 'is-invalid': errors.password }"
                      :placeholder="translate('enter_password')" aria-label="RegisterPassword"
                      aria-describedby="RegisterPassword" autocomplete="new-password" required
                      @input="errors.password = ''" />
                    <button type="button" class="winpot-password-toggle" @click="showPassword = !showPassword"
                      :aria-label="showPassword ? 'Hide password' : 'Show password'">
                      <i v-if="showPassword" class="far fa-eye"></i>
                      <i v-else class="far fa-eye-slash"></i>
                    </button>
                  </div>
                  <div class="winpot-password-hints">
                    <span v-for="hint in passwordHints" :key="hint.id" class="winpot-password-hint"
                      :class="passwordHintClass(hint.valid)">
                      {{ hint.label }}
                    </span>
                  </div>
                  <div class="invalid-feedback" v-if="errors.password">{{ errors.password }}</div>
                </div>
                <div v-if="skin.register_fields.phone_number" class="mb-3 winpot-field">
                  <label class="winpot-label" for="registerPhoneStepOne">{{
                    translate("Número de Teléfono")
                  }}</label><span v-if="!phone_code_checked" style="
                      color: #842029;
                      background-color: #f8d7da;
                      border-color: #f5c2c7;
                      border: 1px solid transparent;
                      border-radius: 0.25rem;
                    " class="px-2">{{ translate("incorrect_code") }}</span>
                  <div class="d-flex winpot-phone-row">
                    <div class="input-group me-1 winpot-phone-prefix">
                      <span class="input-group-text winpot-phone-addon">+</span>
                      <input :style="!phone_code_checked ? 'border-color:red;' : ''" type="number" v-model="phone_code"
                        class="form-control winpot-input" :placeholder="translate('country_code')"
                        :disabled="skin.register_fields.default_phone_code != 0" aria-label="registerPhoneCode" />
                    </div>
                    <div class="winpot-phone-number">
                      <input id="registerPhoneStepOne" v-model.trim="new_user_data.phone" type="tel"
                        pattern="[0-9]{7,15}" class="form-control winpot-input" :class="{ 'is-invalid': errors.phone }"
                        :placeholder="translate('enter_number')" required @input="errors.phone = ''" />
                      <div class="invalid-feedback" v-if="errors.phone">{{ errors.phone }}</div>
                    </div>
                  </div>
                </div>
                <div class="form-check mb-3 winpot-check">
                  <input id="registerAgreement" class="form-check-input" type="checkbox" value="" v-model="agreement"
                    required />
                  <label class="form-check-label winpot-check__label" for="registerAgreement">
                    {{ translate("aggrement") }}
                    <span @click="terms()" class="winpot-link">{{
                      translate("see_aggrement")
                    }}</span>
                  </label>
                </div>
                <button type="submit" class="winpot-button winpot-button--primary">
                  {{ translate("Siguiente") }}
                </button>
                <button data-bs-target="#registerModalToggle2" data-bs-toggle="modal" data-bs-dismiss="modal"
                  id="nextForm" style="display: none"></button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="registerModalToggle2" aria-hidden="true" aria-labelledby="registerModalToggleLabel2"
      tabindex="-1" data-bs-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content winpot-modal">
          <div class="modal-header winpot-modal__header">
            <div @click="openSupportModalJivo()" class="winpot-modal__icon-btn winpot-modal__support">
              <img src="https://winpot.mx/assets/images/support.svg" alt="support" class="winpot-modal__icon" />
            </div>
            <div style="display: flex;align-items: center;">
              <!-- boton para retroceder -->
              <div style="display: flex;position: relative;">
                <button type="button" class="winpot-progress__back" data-bs-target="#registerModalToggle"
                  data-bs-toggle="modal" data-bs-dismiss="modal" aria-label="Back">
                  <svg viewBox="0 0 20 20" class="winpot-modal__back-icon" aria-hidden="true">
                    <path d="M11.5 4.5L6 10l5.5 5.5" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="1.8" />
                  </svg>
                </button>
              </div>
              <!-- progreso -->
              <div class="winpot-progress">
                <div class="winpot-progress__wrapper">
                  <span class="winpot-progress__indicator winpot-progress__indicator--done" aria-hidden="true">
                    <svg viewBox="0 0 8 6" class="winpot-progress__check">
                      <path d="M7 1L3 5L1 2.9" fill="none" stroke="currentColor" stroke-linecap="round"
                        stroke-linejoin="round" stroke-width="1.4" />
                    </svg>
                  </span>
                  <span class="winpot-progress__line" aria-hidden="true"></span>
                  <span class="winpot-progress__indicator winpot-progress__indicator--current"
                    aria-hidden="true"></span>
                </div>
              </div>
            </div>


            <button id="closeRegister" type="button" class="winpot-modal__icon-btn winpot-modal__close"
              data-bs-dismiss="modal" aria-label="Close">
              <img src="https://winpot.mx/assets/images/close.svg" alt="close" class="winpot-modal__icon" />
            </button>
          </div>
          <div class="modal-body winpot-modal__body">
            <div class="winpot-step">

              <h5 class="winpot-modal__stage-title">{{ translate("end_registration") }}</h5>
              <div v-if="status.result != 'OK'" class="alert alert-danger winpot-alert" role="alert">
                {{ status.msg }}
              </div>
              <form class="winpot-form" @submit.prevent="register()">
                <div v-if="skin.register_fields.idn" class="mb-3 winpot-field">
                  <label class="winpot-label" for="registerId">{{
                    translate("Número de Identificación (CURP)")
                  }}</label>
                  <span v-if="cpf_loading" class="spinner-border" :style="skin.loader" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                  <span v-if="
                    skin.register_fields.cpf_verification && cpf_message != ''
                  " v-html="cpf_message" style="
                      color: #842029;
                      background-color: #f8d7da;
                      border-color: #f5c2c7;
                      border: 1px solid transparent;
                      border-radius: 0.25rem;
                    " class="px-2"></span>
                  <input v-model="idn" type="text" id="registerId" class="form-control winpot-input"
                    :class="{ 'is-invalid': errors.idn }" :placeholder="translate('enter_here')"
                    pattern="^[a-zA-Z0-9_]{5,}$" aria-label="registerId" aria-describedby="registerId"
                    @input="errors.idn = ''" @blur="handleIdnChange" />
                  <div class="invalid-feedback" v-if="errors.idn">{{ errors.idn }}</div>
                </div>
                <div v-if="skin.register_fields.name" class="mb-3 winpot-field">
                  <label class="winpot-label" for="registerFirstName">{{ translate("name") }}</label>
                  <input v-model="new_user_data.firstname" type="text" id="registerFirstName"
                    class="form-control winpot-input" :class="{ 'is-invalid': errors.firstname }"
                    :placeholder="translate('enter_here')" aria-label="registerFirstName"
                    aria-describedby="registerFirstName" :readonly="skin.register_fields.cpf_verification" required
                    @input="errors.firstname = ''" />
                  <div class="invalid-feedback" v-if="errors.firstname">{{ errors.firstname }}</div>
                </div>
                <div v-if="skin.register_fields.last_name" class="mb-3 winpot-field">
                  <label class="winpot-label" for="registerLastName">{{
                    translate("last_name")
                  }}</label>
                  <input v-model="new_user_data.last_name" type="text" id="registerLastName"
                    pattern="^[a-zA-Z0-9_]{3,}$" class="form-control winpot-input"
                    :class="{ 'is-invalid': errors.last_name }" :placeholder="translate('enter_here')"
                    aria-label="registerLastName" aria-describedby="registerLastName" required
                    @input="errors.last_name = ''" />
                  <div class="invalid-feedback" v-if="errors.last_name">{{ errors.last_name }}</div>
                </div>
                <div v-if="skin.register_fields.second_last_name" class="mb-3 winpot-field">
                  <label class="winpot-label" for="registerSecondLastName">
                    {{ secondLastNameLabel }}
                  </label>
                  <input v-model="new_user_data.second_lastname" type="text" id="registerSecondLastName"
                    pattern="^[a-zA-Z0-9_]{3,}$" class="form-control winpot-input"
                    :class="{ 'is-invalid': errors.second_lastname }" :placeholder="translate('enter_here')"
                    aria-label="registerSecondLastName" aria-describedby="registerSecondLastName" required
                    @blur="errors.second_lastname = ''" @input="errors.second_lastname = ''" />
                  <div class="invalid-feedback" v-if="errors.second_lastname">{{ errors.second_lastname }}</div>
                </div>
                <div v-if="skin.register_fields.cpf_verification" class="mb-3 winpot-field">
                  <label class="winpot-label" for="birthday">{{
                    translate("birthday")
                  }}</label>
                  <input v-model="birthday" type="text" id="birthday" class="form-control winpot-input"
                    :placeholder="birthdayPlaceholder" aria-label="birthday" aria-describedby="birthday" readonly />
                </div>
                <div v-if="skin.register_fields.name" class="mb-3 winpot-field">
                  <label class="winpot-label" for="registeremail">{{
                    translate("email")
                  }}</label>
                  <input v-model="new_user_data.email" type="email" id="registeremail" class="form-control winpot-input"
                    :class="{ 'is-invalid': errors.email }" :placeholder="translate('enter_here')"
                    aria-label="registeremail" aria-describedby="registeremail" required @input="errors.email = ''" />
                  <div class="invalid-feedback" v-if="errors.email">{{ errors.email }}</div>
                </div>
                <div v-if="skin.register_fields.country" class="mb-3 winpot-field">
                  <label class="winpot-label" for="registerCountry">{{
                    translate("country")
                  }}</label>
                  <select class="form-control winpot-input winpot-select" name="country" v-model="new_user_data.country"
                    id="registerCountry" required>
                    <option v-for="(country, index) in countries" :key="index" :value="country.code">
                      {{ currentLanguage == "es" ? country.name_es : country.name_en }}
                    </option>
                  </select>
                </div>
                <div v-if="skin.register_fields.currency" class="mb-3 winpot-field">
                  <label class="winpot-label" for="registerCurrency">{{
                    translate("currency")
                  }}</label>
                  <select class="form-control winpot-input winpot-select" name="currency"
                    v-model="new_user_data.currency" id="registerCurrency" required>
                    <option v-for="currency in currencies" :key="currency" :value="currency">
                      {{ currency }}
                    </option>
                  </select>
                </div>
                <div class="text-center">
                  <span v-if="register_inProcess" class="spinner-border" :style="skin.loader" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                </div>
                <button type="submit" class="winpot-button winpot-button--primary" :disabled="register_inProcess">
                  {{ translate("Registrate") }}
                </button>

              </form>
              <button data-bs-target="#registerModalToggle3ganamos" data-bs-toggle="modal" data-bs-dismiss="modal"
                style="display: none" id="registerSuccessfull"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="registerModalToggle3ganamos" aria-hidden="true"
      aria-labelledby="registerModalToggleLabel3" tabindex="-1" data-bs-backdrop="false"
      style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content winpot-modal">
          <div class="modal-header winpot-modal__header">
            <span class="winpot-modal__icon-spacer" aria-hidden="true"></span>
            <button type="button" class="winpot-modal__icon-btn winpot-modal__close" data-bs-dismiss="modal"
              aria-label="Close">
              <img src="https://winpot.mx/assets/images/close.svg" alt="close" class="winpot-modal__icon" />
            </button>
          </div>
          <div class="modal-body winpot-modal__body">
            <div class="text-center p-2 winpot-success">
              <span class="winpot-success__icon"><i class="fas fa-check-circle"></i></span><br />
              <h3 class="winpot-modal__title winpot-modal__title--success">{{ translate("register_success") }}</h3>
              <p class="winpot-modal__subtitle">{{ translate("can_login") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button data-bs-target="#phoneVericationModal" data-bs-toggle="modal" data-bs-dismiss="modal" style="display: none"
      id="phoneVericationModalBtn"></button>
    <div class="modal fade" id="phoneVericationModal" aria-hidden="true" aria-labelledby="phoneVericationModal"
      tabindex="-1" data-bs-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content winpot-modal">
          <div class="modal-header winpot-modal__header">
            <span class="winpot-modal__section-title">{{ translate("phone_verification") }}</span>
            <button type="button" class="winpot-modal__icon-btn winpot-modal__close" data-bs-dismiss="modal"
              aria-label="Close">
              <img src="https://winpot.mx/assets/images/close.svg" alt="close" class="winpot-modal__icon" />
            </button>
          </div>
          <div class="modal-body winpot-modal__body">
            <div class="text-center">
              <span v-if="phone_verification.loading" class="spinner-border" :style="skin.loader" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
              <div v-else :class="'alert alert-' + phone_verification.message.type" role="alert">
                {{ phone_verification.message.message }}
              </div>
            </div>
            <form v-if="!phone_verification.code_checked" class="text-center p-2 winpot-form"
              @submit.prevent="verify_phone()">
              <input v-model="phone_verification.code" type="number" step="1" required
                class="form-control winpot-input winpot-input--center" /><br /><br />
              <button type="submit" class="winpot-button winpot-button--primary">
                {{ translate("confirm") }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const countriesData = require("../../../assets/countries.json");
import router from "../../../router";
import axios from "axios";
export default {
  name: "register",
  props: ["skin", "translation", "language"],
  data() {
    return {
      selected_country: "",
      email: "",
      password: "",
      first_name: "",
      last_name: "",
      idn: "",
      cpf_message: "",
      cpf_verified: true,
      cpf_loading: false,
      birthday: "",
      gender: "",
      country_code: "",
      phone_code: "52",
      phone_code_checked: true,
      edit_tickets: 0,
      phone_verification: {
        code_checked: false,
        code: "",
        otp_id: "",
        loading: false,
        message: {
          type: "",
          message: "",
        },
      },
      phone: "",
      currency_name: "",
      status: { result: "OK", msg: "" },
      agreement: false,
      showPassword: false,
      register_inProcess: false,
      new_user_data: {
        affiliate_id: "",
        country: "MX",
        type: "",
        username: "",
        email: "",
        firstname: "",
        last_name: "",
        second_lastname: "",
        dni: "",
        password: "",
        phone: "",
        currency: "MXN",
        login_Id: 0,
        poker: 0,
        casino: 0,
        deportes: 0,
        // proveedores: {
        //   poker: { comision: 0,  status: true },
        //   casino: [],
        //   deportes: { status: true, comision: 0 },
        //   bingo: { status: true, comision: 0 },
        //   casinoLive: {  comision: 0, status: true },
        //   hipicas: { status: true, comision: 0 },
        //   casinoTotal: "",
        //   pokerTotal: "",
        //   deportesTotal: "",
        //   bingoTotal: "",
        //   casinoLiveTotal: "",
        //   hipicasTotal: "",
        // },
        error: "",
        liquidacion: "Mensual",
      },
      errors: {
        username: "",
        email: "",
        firstname: "",
        last_name: "",
        second_lastname: "",
        idn: "",
        password: "",
        phone: "",
      }
    };
  },
  computed: {
    jivo_modal_flag() {
      return this.$store.getters["getModalFlag"]
    },
    jivoElement1() {
      return this.$store.getters['jivoElement1'];
    },
    getRoot() {
      return this.$store.getters["getRoot"];
    },
    qtag() {
      let data = this.$store.getters["getQtag"];
      return data;
    },
    user() {
      let data = this.$store.getters["getUserData"];
      return data;
    },
    afiliado() {
      let data = this.$store.getters["getAfiliado"];
      // console.log(data)
      return data;
    },
    currentLanguage() {
      return this.$store.getters['getLanguage'];
    },

    secondLastNameLabel() {
      const translated = this.translate("second_last_name");
      if (translated && translated !== "second_last_name") return translated;

      return this.currentLanguage === 'es' ? 'Segundo Apellido' : this.currentLanguage === 'pt' ? 'Segundo Apelido' : 'Second Last Name';
    },

    userNameLabel() {
      const translated = this.translate("username");
      if (translated && translated !== "username") return translated;

      return this.currentLanguage === 'es' ? 'Nombre de Usuario' : this.currentLanguage === 'pt' ? 'Nome de Usuário' : 'Username';
    },

    registrationSubtitle() {
      if (this.currentLanguage === "es") return "Completa tus datos para continuar";
      if (this.currentLanguage === "pt") return "Preencha seus dados para continuar";
      return "Complete your details to continue";
    },

    birthdayPlaceholder() {
      if (this.currentLanguage === "pt") return "Dia/Mês/Ano";
      if (this.currentLanguage === "en") return "Day/Month/Year";
      return "Día/Mes/Año";
    },


    root() {
      let data = this.$store.getters["getRoot"];
      // console.log(data)
      return data;
    },
    apiUrlnew() {
      const url = this.$store.getters["getApiUrlnew"];

      return url;
    },
    site() {
      return this.$store.getters["getSite"];
    },
    supportPhoneUrl() {
      const phone = this.user?.user_data?.data?.parentPhone;
      return phone ? `https://api.whatsapp.com/send?phone=${phone}` : "";
    },
    passwordValidationState() {
      const password = this.new_user_data.password || "";
      return {
        length: password.length >= 8 && password.length <= 20,
        spaces: !/\s/.test(password),
        number: /\d/.test(password),
        uppercase: /[A-Z]/.test(password),
        lowercase: /[a-z]/.test(password),
      };
    },
    isPasswordValid() {
      return Object.values(this.passwordValidationState).every(Boolean);
    },
    passwordHasValue() {
      return (this.new_user_data.password || "").length > 0;
    },
    passwordInvalidMessage() {
      if (this.currentLanguage === "es") {
        return "La contraseña debe tener de 8 a 20 caracteres, sin espacios, con número, mayúscula y minúscula.";
      }
      if (this.currentLanguage === "pt") {
        return "A senha deve ter de 8 a 20 caracteres, sem espaços, com número, letra maiúscula e minúscula.";
      }
      return "Password must be 8 to 20 characters, with no spaces, and include a number, an uppercase letter, and a lowercase letter.";
    },
    passwordHints() {
      const labels = {
        es: {
          length: "8 a 20 caracteres",
          spaces: "Sin espacios",
          number: "Al menos 1 numero",
          uppercase: "Al menos 1 mayuscula",
          lowercase: "Al menos 1 minuscula",
        },
        pt: {
          length: "8 a 20 caracteres",
          spaces: "Sem espaços",
          number: "Pelo menos 1 número",
          uppercase: "Pelo menos 1 letra maiúscula",
          lowercase: "Pelo menos 1 letra minúscula",
        },
        en: {
          length: "8 to 20 characters",
          spaces: "No spaces",
          number: "At least 1 number",
          uppercase: "At least 1 uppercase letter",
          lowercase: "At least 1 lowercase letter",
        },
      };
      const lang = labels[this.currentLanguage] ? this.currentLanguage : "en";
      return [
        { id: "length", valid: this.passwordValidationState.length, label: labels[lang].length },
        { id: "spaces", valid: this.passwordValidationState.spaces, label: labels[lang].spaces },
        { id: "number", valid: this.passwordValidationState.number, label: labels[lang].number },
        { id: "uppercase", valid: this.passwordValidationState.uppercase, label: labels[lang].uppercase },
        { id: "lowercase", valid: this.passwordValidationState.lowercase, label: labels[lang].lowercase },
      ];
    },
    currencies() {
      let root = this.$props.skin.register_fields.root;
      if (
        this.$props.skin &&
        this.$props.skin.register_fields &&
        typeof root === 'object'
      ) {
        const keys = Object.keys(root);
        return keys.sort();
      }
      return ["MXN", "PEN", "CLP", "USD"];
    },

    countries() {
      const allowedCurrencies = this.currencies;
      let filteredCountries = countriesData.countries.filter(country =>
        allowedCurrencies.includes(country.currency)
      );
      return filteredCountries.sort((a, b) => {
        const nameA = a[this.currentLanguage == "es" ? "name_es" : "name_en"];
        const nameB = b[this.currentLanguage == "es" ? "name_es" : "name_en"];
        return nameA.localeCompare(nameB, this.currentLanguage);
      });
    },

    // currencies() {

    //     //a partir de register_fields.root que es un obtejo vamos a obtener las currencys, las currencys
    //     //son las claves del objeto root , el objeto root esta dentro de  state.state.skins[0].register_fields.root
    //     //ENTONCES VAMOS HACER ESO
    //     const root = this
    //   const allCurrencies = this.countries().map(c => c.currency);

    //   // Filtramos para que sean únicas y no estén vacías
    //   const uniqueCurrencies = [...new Set(allCurrencies)].filter(curr => curr && curr !== "");

    //   if (uniqueCurrencies.length > 0) {
    //     // Las devuelve ordenadas alfabéticamente
    //     return uniqueCurrencies.sort();
    //   }

    //   // Fallback por si el JSON no tiene monedas aún
    //   return ["MXN", "PEN", "CLP", "USD","COP"];
    // },

  },
  methods: {
    openSupportModalJivo() {
      const jivoElement = this.jivoElement1;
      if (this.jivo_modal_flag) {
        if (jivoElement) {
          jivoElement.style.display = 'none';
        }
        this.$store.dispatch("setJivo_modal_flag", false);
      } else {
        if (jivoElement) {
          jivoElement.style.display = 'block';
          jivo_api.open()
        }
        setTimeout(() => {
          jivo_api.open()
        }, 600);
        this.$store.dispatch("setJivo_modal_flag", true);
        this.$store.dispatch("setMessage", false);
      }
    },
    capializeFirst(text) {
      if (!text) { return "" }
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    normalizeUsername(event) {
      this.new_user_data.username = event.target.value.replace(/\s/g, "");
      this.errors.username = "";
    },
    passwordHintClass(valid) {
      if (!this.passwordHasValue) return "";
      return valid ? "success" : "unsuccessful";
    },

    terms() {
      let url = "";
      let lang =
        this.$props.language == "es"
          ? "spa"
          : this.$props.language == "en"
            ? "eng"
            : this.$props.language == "pt"
              ? "pt-br"
              : "spa";
      if (this.user.prefix == "external") {
        url =
          "https://docs.sistemasw3.com/terms/" +
          lang +
          "/?site=" +
          this.user.site.toUpperCase() +
          "&link=" +
          this.user.site;
      } else {
        let domain_formated = this.user.domain.split("//")[1];
        let domain_name1 = domain_formated.split(".")[1].toUpperCase();
        let domain_name2 =
          domain_formated.split(".")[1] + "." + domain_formated.split(".")[2];
        url =
          "https://docs.sistemasw3.com/terms/" +
          lang +
          "/?site=" +
          domain_name1 +
          "&link=" +
          domain_name2;
      }

      window.open(url, "_blank").focus();
    },
    async register() {
      this.register_inProcess = true;
      // Limpiar errores previos
      Object.keys(this.errors).forEach(key => this.errors[key] = "");
      this.status.msg = "";
      this.status.result = "OK";

      let response;
      try {
        if (!this.isPasswordValid) {
          this.errors.password = this.passwordInvalidMessage;
          this.status.result = "error";
          this.status.msg = this.passwordInvalidMessage;
          this.register_inProcess = false;
          return;
        }
        let loginInfo =
          this.new_user_data.username != "" && this.new_user_data.password != ""
            ? true
            : false;
        if (!loginInfo) {
          this.status.result = "error";
          if (this.language === "es") {
            this.status.msg = "Debes completar los datos de Ingreso";
          } else if (this.language === "pt") {
            this.status.msg = "Você deve preencher os dados de login";
          } else {
            this.status.msg = "You must complete the login data";
          }
          this.register_inProcess = false;
          return;
        } else {
          let data = {};
          //aca en data country vamos a pasar es el codigo de pais que viene de new_user_data.country que es un objeto
          data.country = this.new_user_data.country;
          data.username = this.new_user_data.username;
          data.email = this.new_user_data.email;
          data.firstname = this.new_user_data.firstname;
          data.lastname = this.new_user_data.last_name;
          data.second_lastname = this.new_user_data.second_lastname;
          data.password = this.new_user_data.password;
          data.phone = this.phone_code + this.new_user_data.phone;
          data.dni = this.idn;
          data.edit_tickets = this.edit_tickets;
          data.root = this.$store.state.skins[0].register_fields.root[this.new_user_data.currency]
          if (this.qtag !== null && this.qtag !== undefined && this.qtag !== "") {
            data.root = Number(this.qtag);
          }

          let endpoint = "user/register";
          const source = router.currentRoute.query.source ?? '';
          if (source === "qr") {
            endpoint += "?source=qr";
          }

          response = await axios.post(this.apiUrlnew + endpoint, data);

          if (response.data.error) {
            this.handleServerError(response.data.message || response.data.error);
          } else {
            this.$store.dispatch("storeQtag", data.affiliate_id);
            this.register_inProcess = false;
            document.getElementById("registerSuccessfull").click();
            document.getElementById("closeRegister").click();
            this.resetForm(); // Limpiar después de un registro exitoso
          }
        }
      } catch (error) {
        this.register_inProcess = false;
        const msg = error.response?.data?.message || error.response?.data?.error || "Error al registrar el usuario";
        this.handleServerError(msg);
      }
    },
    handleServerError(msg) {
      this.status.result = "error";

      if (Array.isArray(msg)) {
        msg = msg[0];
      }

      let displayMsg = msg;
      const lowerMsg = msg.toLowerCase();
      const isEs = this.currentLanguage === 'es';
      let matched = false;

      // Detectamos el campo afectado y asignamos el mensaje hardcodeado según el idioma
      if (lowerMsg.includes("usuario padre")) {
        displayMsg = isEs ? "Error, usuario padre no encontrado." : this.currentLanguage === 'pt' ? "Usuário pai não encontrado." : "Parent user not found.";
        matched = true;
      } else if (lowerMsg.includes("high-risk")) {
        displayMsg = isEs ? "Tu verificación está en proceso. Por el momento no podemos habilitar tu cuenta" : this.currentLanguage === 'pt' ? "Sua verificação está em andamento. No momento, não podemos habilitar sua conta." : "Your verification is in progress. We cannot enable your account at this time.";
        this.errors.idn = displayMsg;
        matched = true;
      }
      else if (lowerMsg.includes("curp")) {
        displayMsg = isEs ? "El formato de la CURP es incorrecto. Por favor, verifica cada carácter e inténtalo nuevamente." : this.currentLanguage === 'pt' ? "O formato da CURP é inválido. Verifique cada caractere e tente novamente." : "The CURP format is invalid. Please check each character and try again.";
        matched = true;
      }
      else if (lowerMsg.includes("deliverable")) {
        displayMsg = isEs ? "El correo electrónico no es válido." : this.currentLanguage === 'pt' ? "Este e-mail não pode receber mensagens." : "This email address cannot receive messages.";
        matched = true;
      }
      else if (lowerMsg.includes("usuario") || lowerMsg.includes("username")) {
        displayMsg = isEs ? "El nombre de usuario ya existe." : this.currentLanguage === 'pt' ? "O nome de usuário já existe." : "Username already exists.";
        this.errors.username = displayMsg;
        matched = true;
      }
      else if (lowerMsg.includes("email") || lowerMsg.includes("correo")) {
        displayMsg = isEs ? "El correo electrónico ya está registrado." : this.currentLanguage === 'pt' ? "Este e-mail já está cadastrado." : "This email address is already registered.";
        this.errors.email = displayMsg;
        matched = true;
      }
      else if (lowerMsg.includes("password") || lowerMsg.includes("contraseña")) {
        displayMsg = isEs ? "La contraseña no es válida o es muy corta." : this.currentLanguage === 'pt' ? "A senha é inválida ou muito curta." : "Your password is invalid or too short.";
        this.errors.password = displayMsg;
        matched = true;
      }
      else if (lowerMsg.includes("dni") || lowerMsg.includes("documento") || lowerMsg.includes("identificación") || lowerMsg.includes("cpf")) {
        displayMsg = isEs ? "El número de documento no es válido o ya está registrado." : this.currentLanguage === 'pt' ? "O número do documento é inválido ou já está cadastrado." : "The document number is invalid or already registered.";
        this.errors.idn = displayMsg;
        matched = true;
      }
      else if (lowerMsg.includes("nombre") || lowerMsg.includes("firstname")) {
        displayMsg = isEs ? "El nombre ingresado no es válido." : this.currentLanguage === 'pt' ? "O nome inserido não é válido." : "The entered name is not valid.";
        this.errors.firstname = displayMsg;
        matched = true;
      }
      else if (lowerMsg.includes("token")) {
        displayMsg = isEs ? "El token es inválido o no corresponde al usuario." : this.currentLanguage === 'pt' ? "O token é inválido ou não corresponde ao usuário." : "The token is invalid or does not match the user.";
        this.errors.token = displayMsg;
        matched = true;
      }
      else if (lowerMsg.includes("segundo apellido") || lowerMsg.includes("second_lastname")) {
        displayMsg = isEs ? "El segundo apellido ingresado no es válido." : this.currentLanguage === 'pt' ? "O segundo sobrenome informado é inválido." : "The second last name entered is invalid.";
        this.errors.second_lastname = displayMsg;
        matched = true;
      }
      else if (lowerMsg.includes("apellido") || lowerMsg.includes("lastname")) {
        displayMsg = isEs ? "El apellido ingresado no es válido." : this.currentLanguage === 'pt' ? "O sobrenome informado é inválido." : "The last name entered is invalid.";
        this.errors.last_name = displayMsg;
        matched = true;
      }
      else if (lowerMsg.includes("teléfono") || lowerMsg.includes("phone") || lowerMsg.includes("celular")) {
        displayMsg = isEs ? "El número de teléfono ya está registrado o es inválido." : this.currentLanguage === 'pt' ? "O número de telefone já está cadastrado ou é inválido." : "This phone number is already registered or invalid.";
        this.errors.phone = displayMsg;
        matched = true;
      }

      if (lowerMsg.includes("internal server error")) {
        if (this.currentLanguage === "es") {
          displayMsg = "Error interno del servidor. Por favor, inténtalo más tarde.";
        } else if (this.currentLanguage === "pt") {
          displayMsg = "Erro interno do servidor. Por favor, tente novamente mais tarde.";
        } else {
          displayMsg = "Internal server error. Please try again later.";
        }
      } else if (!matched) {

        if (this.currentLanguage === "es") {
          displayMsg = "Ha ocurrido un error. Por favor, inténtalo de nuevo.";
        } else if (this.currentLanguage === "pt") {
          displayMsg = "Ocorreu um erro. Por favor, tente novamente.";
        } else {
          displayMsg = "An error occurred. Please try again.";
        }
      }

      this.status.msg = displayMsg;
    },
    resetForm() {
      // Reiniciar datos del usuario con valores por defecto
      this.new_user_data = {
        affiliate_id: "",
        country: this.$props.skin.register_fields.default_country || "MX",
        type: "",
        username: "",
        email: "",
        firstname: "",
        last_name: "",
        second_lastname: "",
        dni: "",
        password: "",
        phone: "",
        currency: this.$props.skin.register_fields.default_currency || "MXN",
        login_Id: 0,
        poker: 0,
        casino: 0,
        deportes: 0,
        error: "",
        liquidacion: "Mensual",
      };

      // Reiniciar campos auxiliares
      this.idn = "";
      this.birthday = "";
      this.phone = "";
      this.phone_code = this.$props.skin.register_fields.default_phone_code || "52";
      this.agreement = false;
      this.cpf_message = "";
      this.cpf_verified = true;

      // Reiniciar estados de error y proceso
      this.status = { result: "OK", msg: "" };
      this.register_inProcess = false;

      // Limpiar objeto de errores
      Object.keys(this.errors).forEach(key => this.errors[key] = "");
    },
    async storeQtag(state, payload) {
      document.cookie = `qtag=${payload}; path=/; max-age=31536000`; // Caducidad de 1 día (86400 segundos)
    },

    async verify_dni() {
      try {
        const response = await axios.get(
          "https://admin.eujogo.bet/deposit/bs2/checkdni",
          { params: { dni: this.idn } }
        );

        const data = response.data.data;

        if (data?.nascimento) {
          this.applyDocumentData(data);
          return true;
        }
      } catch (e) { }

      return false;
    },

    async verify_cpf() {
      if (this.$props.skin.register_fields.cpf_verification && this.idn != "") {
        this.cpf_loading = true;
        const response = await axios.get(
          "https://admin.eujogo.bet/deposit/bs2/checkcpf?cpf=" + this.idn
        );
        if (response.data.data.nascimento) {
          const date = response.data.data.nascimento;
          this.new_user_data.firstname = response.data.data.nome;
          this.birthday =
            date.slice(0, 2) + "/" + date.slice(2, 4) + "/" + date.slice(4, 8);
          this.cpf_verified = true;
          this.cpf_loading = false;
          this.cpf_message = "";
        } else {
          this.cpf_message = response.data.data.mensagem;
          this.birthday = "";
          this.cpf_verified = false;
          this.cpf_loading = false;
        }
      }
    },
    handleIdnChange() {
      if (this.skin.register_fields.cpf_verification) {
        this.verify_cpf();
      }
    },
    async send_phone_code(flag) {
      if (flag == 2) {
        this.phone_verification.loading = true;
        let data_phone = {
          command: "verify_phone",
          params: {
            phone: this.new_user_data.phone.replace("+", "").substring(2),
            code: this.new_user_data.phone.replace("+", "").slice(0, 2),
          },
        };
        const response_phone_verification = await axios.post(
          this.user.domain +
          "/" +
          this.user.prefix +
          "/scommand?access_token=" +
          this.user.token +
          "&site=" +
          this.user.site,
          data_phone
        );
        document.getElementById("phoneVericationModalBtn").click();
        this.phone_verification.message.message =
          response_phone_verification.data.message;
        this.phone_verification.message.type = response_phone_verification.data
          .success
          ? "success"
          : "danger";
        this.phone_verification.loading = false;
        return "success";
      } else {
        this.phone_verification.loading = true;
        let phone_data = {
          phone_code: this.phone_code,
          phone: this.phone.replace(".", ""),
          lang: this.$props.language,
        };
        let phone_response = await axios.post(
          "https://jbets.online:3012/api/generate_otp",
          phone_data
        );
        if (
          phone_response.data.otp_id &&
          (phone_response.data.status
            ? phone_response.data.status == "OPEN"
              ? true
              : false
            : false)
        ) {
          this.phone_verification.otp_id = phone_response.data.otp_id;
          document.getElementById("phoneVericationModalBtn").click();
          this.phone_verification.message.message = phone_response.data.message;
          this.phone_verification.message.type = "success";
          this.phone_verification.loading = false;
          this.register_inProcess = false;
          return "success";
        }
        this.register_inProcess = false;
        return "failed";
      }
    },
    async verify_phone() {
      if (this.phone_verification.otp_id == "") {
        this.phone_verification.loading = true;
        let data_phone = {
          command: "check_verify_phone",
          params: { code: this.phone_verification.code },
        };
        const response_phone_verification = await axios.post(
          this.user.domain +
          "/" +
          this.user.prefix +
          "/scommand?access_token=" +
          this.user.token +
          "&site=" +
          this.user.site,
          data_phone
        );
        if (response_phone_verification.data.success) {
          this.phone_verification.message.message =
            response_phone_verification.data.message;
          this.phone_verification.message.type = "success";
          this.phone_verification.code_checked = true;
          this.phone_verification.loading = false;
        } else {
          this.phone_verification.message.message =
            response_phone_verification.data.message;
          this.phone_verification.message.type = "danger";
          this.phone_verification.code_checked = false;
          this.phone_verification.loading = false;
        }
      } else {
        this.phone_verification.loading = true;
        let data_phone = {
          otp_id: this.phone_verification.otp_id,
          code: this.phone_verification.code,
          lang: this.$props.language,
        };
        let phone_response = await axios.post(
          "https://jbets.online:3012/api/verify_otp",
          data_phone
        );
        if (phone_response.data.status) {
          this.phone_verification.message.message = phone_response.data.message;
          this.phone_verification.message.type = "success";
          this.phone_verification.code_checked = true;
          this.phone_verification.loading = false;
          this.phone_verification.otp_id = "";
          this.register();
        } else {
          this.phone_verification.message.message = phone_response.data.message;
          this.phone_verification.message.type = "danger";
          this.phone_verification.code_checked = false;
          this.phone_verification.loading = false;
        }
      }
    },
    nextStep(event) {
      const form = event?.target;
      if (form && !form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (!this.isPasswordValid) {
        this.errors.password = this.passwordInvalidMessage;
        return;
      }
      if (this.skin.register_fields.phone_number && !this.phone_code_checked) {
        this.errors.phone = this.translate("incorrect_code");
        return;
      }
      document.getElementById("nextForm").click();
    },

    translate(text) {
      if (text && this.translation) {
        if (this.translation[text]) {
          return this.translation[text][this.currentLanguage];
        } else {
          var new_text_searched = text.replace(/ /g, "_");
          if (this.translation[new_text_searched]) {
            return this.translation[new_text_searched][this.currentLanguage];
          }
        }
        return text;
      }
      return text;
    },
  },
  watch: {


    phone_code(newVal) {
      let code = "+" + newVal;
      let checkCode = false;
      this.countries.forEach((country) => {
        if (code == country.dial_code) {
          checkCode = true;
        }
      });
      this.phone_code_checked = checkCode;
      if (checkCode && this.errors.phone === this.translate("incorrect_code")) {
        this.errors.phone = "";
      }
    },

    'new_user_data.country'(newIsoVal) {

      const selectedCountry = this.countries.find(c => c.code === newIsoVal);

      if (selectedCountry && selectedCountry.currency) {
        this.new_user_data.currency = selectedCountry.currency;
        this.phone_code = selectedCountry.dial_code.replace("+", "");

      }
    },

    'new_user_data.currency'(newCurrVal) {
      // 1. Buscamos el país actual para ver si ya coincide con la nueva moneda
      const currentCountry = this.countries.find(c => c.code === this.new_user_data.country);

      // 2. Si el país que ya está seleccionado NO usa la nueva moneda, buscamos uno que sí
      if (!currentCountry || currentCountry.currency !== newCurrVal) {
        const compatibleCountry = this.countries.find(c => c.currency === newCurrVal);

        if (compatibleCountry) {
          this.new_user_data.country = compatibleCountry.code;
          this.phone_code = compatibleCountry.dial_code.replace("+", "");
        }
      }
    },
    //   'new_user_data.country'(newVal, oldVal) {
    //   console.log('Country changed');
    //   console.log('Anterior:', oldVal);
    //   console.log('Nuevo:', newVal);
    // },
  },
  mounted() {
    const source = router.currentRoute.query.source ?? '';
    if (source && this.user?.token === '') {
      this.$nextTick(() => {
        const registerButton = document.getElementById("register_btn");
        if (registerButton) {
          registerButton.click();
        }
      });
    }

    if (this.$props.skin.register_fields.default_country != "") {
      this.country_code = this.$props.skin.register_fields.default_country;
    }
    if (this.$props.skin.register_fields.default_phone_code != 0) {
      this.phone_code = this.$props.skin.register_fields.default_phone_code;
    }
    if (this.$props.skin.register_fields.default_currency != "") {
      this.currency_name = this.$props.skin.register_fields.default_currency;
    }
    this.$root.$on("send_phone_code", () => {
      this.send_phone_code(2);
    });


    const modalIds = ['registerModalToggle', 'registerModalToggle2', 'registerModalToggle3ganamos'];
    modalIds.forEach(id => {
      const modalElement = document.getElementById(id);
      if (modalElement) {
        modalElement.addEventListener('hidden.bs.modal', () => {
          // Esperamos un momento a que la transición de Bootstrap avance
          setTimeout(() => {
            // Buscamos si alguno de los modales de registro tiene la clase 'show' (está visible)
            const anyOpen = document.querySelector('#registerModalToggle.show, #registerModalToggle2.show, #registerModalToggle3ganamos.show');

            // Si no hay ninguno abierto y no estamos en medio de una petición... ahí sí reseteamos
            if (!anyOpen && !this.register_inProcess) {
              this.resetForm();
            }
          }, 500); // 500ms es tiempo suficiente para que el siguiente modal empiece a mostrarse
        });
      }
    });
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Teko:wght@400;500;600&display=swap");

.winpot-modal__logo {
  margin-bottom: 7px;
}

.winpot-register {
  --winpot-text: #2d2a26;
  --winpot-muted: #6f7485;
  --winpot-border: #9ca4bf;
  --winpot-surface: #f5f6fa;
  --winpot-accent: #87f031;
  --winpot-accent-hover: #8fe846;
  --winpot-accent-soft: #c8f0a8;
  --winpot-shadow: 0 6px 30px rgba(0, 0, 0, 0.1);
  font-family: "Montserrat", sans-serif;
}

.winpot-register .modal-dialog {
  max-width: 414px;
}

.winpot-modal {
  border: 0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: var(--winpot-shadow);
  overflow: hidden;
}

.winpot-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  padding: 16px 16px 14px;
  border-bottom: 0;
}

.winpot-modal__icon-btn,
.winpot-modal__icon-spacer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
  opacity: 1;
}

.winpot-modal__icon-btn {
  color: #999dad;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.winpot-modal__icon-btn:hover {
  opacity: 0.85;
}

.winpot-modal__close:hover {
  transform: rotate(-90deg);
}

.winpot-modal__icon-btn:focus {
  box-shadow: none;
}

.winpot-modal__icon {
  width: 24px;
  height: 24px;
}

.winpot-modal__back-icon {
  width: 18px;
  height: 18px;
  color: var(--winpot-text);
}

.winpot-modal__body {
  padding: 0 16px 32px;
}

.winpot-modal__intro {
  margin-top: 6px;
  margin-bottom: 18px;
  text-align: center;
}



.winpot-progress__wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
}

.winpot-progress__back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  padding: 0;
  flex: 0 0 auto;
}

.winpot-progress__indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1px solid var(--winpot-text);
  border-radius: 50%;
  color: var(--winpot-text);
  flex: 0 0 18px;
}

.winpot-progress__indicator::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
}

.winpot-progress__indicator--inactive {
  border-color: #9e9e9e;
  color: #9e9e9e;
}

.winpot-progress__indicator--done {
  border-color: #12845b;
  background: #12845b;
  color: #ffffff;
}

.winpot-progress__indicator--done::before {
  display: none;
}

.winpot-progress__check {
  width: 8px;
  height: 6px;
}

.winpot-progress__line {
  width: 64px;
  height: 1px;
  margin: 0 8px;
  background: #9e9e9e;
}

.winpot-progress__line--done {
  background: #555353;
}

.winpot-modal__stage-title {
  margin: 0 0 12px;
  color: var(--winpot-text);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
  text-align: center;
}


.winpot-modal__kicker {
  margin: 0 0 8px;
  color: #6f7485;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.winpot-modal__title {
  margin: 0 0 10px;
  color: var(--winpot-text);
  font-size: 18px;
  font-weight: 700;
  line-height: 0.95;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-family: "Montserrat", sans-serif;
}

.winpot-modal__title--success {
  font-size: 30px;
}

.winpot-modal__subtitle {
  margin: 0;
  color: var(--winpot-text);
  font-size: 12px;
  line-height: 1.5;
}

.winpot-modal__section-title {
  margin: 0;
  color: var(--winpot-text);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
}

.winpot-field {
  margin-bottom: 10px !important;
}

.winpot-label {
  display: block;
  margin-bottom: 5px;
  color: var(--winpot-text);
  font-size: 13px;
  line-height: 17px;
  font-weight: 500;
  text-align: left;
}

.winpot-input,
.winpot-select {
  min-height: 48px;
  padding: 12px 16px;
  border: 1px solid var(--winpot-border);
  border-radius: 4px;
  background: var(--winpot-surface);
  color: var(--winpot-text);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.25;
  box-shadow: none;
}

.winpot-input::placeholder {
  color: #999dad;
}

.winpot-input:focus,
.winpot-select:focus {
  border-color: #7d87a7;
  background: var(--winpot-surface);
  box-shadow: none;
}

.winpot-input[readonly],
.winpot-input:disabled,
.winpot-select:disabled {
  background: #eef0f6;
  opacity: 1;
}

.winpot-select {
  appearance: auto;
}

.winpot-password-wrapper {
  position: relative;
}

.winpot-password-wrapper .winpot-input {
  padding-right: 48px;
}

.winpot-password-toggle {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #9ca4bf;
}

.winpot-password-hints {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 3px;
  margin-left: -7px;
  padding-top: 4px;
}

.winpot-password-hint {
  position: relative;
  display: inline-block;
  padding-left: 15px;
  color: var(--winpot-text);
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
  padding-left: 22px;
}

.winpot-password-hint::before {
  content: "";
  height: 8px;
  left: 8px;
  position: absolute;
  top: 4px;
  width: 8px;
  border-radius: 50%;
  background-color: #9ca4bf;
}

.winpot-password-hint.success::before {
  height: 12px;
  left: 7px;
  top: 2px;
  width: 12px;
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' viewBox='0 0 12 12'%3E%3Cpath stroke='%2300ca45' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m11 2-6.667 8L1 5.79'/%3E%3C/svg%3E") no-repeat 50%;
}

.winpot-password-hint.unsuccessful::before {
  height: 12px;
  left: 7px;
  top: 2px;
  width: 12px;
  margin-right: 2px;
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' viewBox='0 0 12 12'%3E%3Cpath stroke='%23c82c16' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m10 2-8 8M2 2l8 8'/%3E%3C/svg%3E") no-repeat 50%;
}

.winpot-button {
  width: 100%;
  min-height: 54px;
  margin-bottom: 12px;
  border-radius: 4px;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.1;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
}

.winpot-button--primary {
  border: 0;
  background: var(--winpot-accent);
  color: var(--winpot-text);
}

.winpot-button--primary:hover:not(:disabled) {
  background: var(--winpot-accent-hover);
}

.winpot-button--primary:disabled {
  background: var(--winpot-accent-soft);
  color: rgba(45, 42, 38, 0.7);
}

.winpot-button--secondary {
  border: 1px solid var(--winpot-text);
  background: transparent;
  color: var(--winpot-text);
}

.winpot-button--secondary:hover {
  background: rgba(45, 42, 38, 0.04);
}

.winpot-alert {
  margin-bottom: 12px;
  border-radius: 4px;
  font-size: 12px;
}

.winpot-phone-row {
  gap: 8px;
}

.winpot-phone-prefix {
  width: 30%;
}

.winpot-phone-number {
  width: 70%;
}

.winpot-phone-addon {
  border: 1px solid var(--winpot-border);
  border-right: 0;
  background: var(--winpot-surface);
  color: var(--winpot-text);
}

.winpot-check {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.winpot-check .form-check-input {
  width: 20px;
  height: 20px;
  position: absolute;
  margin-top: 0;
  border: 1px solid var(--winpot-text);
  border-radius: 2px;
  box-shadow: none;
}

.winpot-check .form-check-input:checked {
  background-color: var(--winpot-accent);
  border-color: var(--winpot-text);
}

.winpot-check__label {
  color: var(--winpot-text);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.45;
  margin-left: 5px;
}

.winpot-link {
  color: var(--winpot-text);
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.winpot-success {
  text-align: center;
}

.winpot-success__icon {
  font-size: 64px;
  color: #4eb91f;
}

.winpot-input--center {
  text-align: center;
}

.winpot-register .invalid-feedback {
  display: block;
  margin-top: 4px;
  color: #d43b3b;
  font-size: 11px;
  line-height: 13px;
}

@media (max-width: 480px) {
  .winpot-register .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  .winpot-modal {
    min-height: 100vh;
    border-radius: 0;
  }

  .winpot-modal__body {
    padding-bottom: 24px;
  }

  .winpot-modal__title {
    font-size: 16px;
  }
}
</style>
